module.exports = __webpack_public_path__ + "static/media/large-wegovy-green.76cdae06.png";